import { createAgencyAllowIp } from './createAgencyIpList'
import { destroyAgencyAllowIp } from './destroyAgencyAllowIp'
import { fetchAgencyIpList } from './fetchAgencyIpList'

export const agencyIps = () => {
  return {
    index(agencyCode: string | null, page: number) {
      return fetchAgencyIpList(agencyCode, page)
    },
    create(agencyCode: string, ipAddress: string) {
      return createAgencyAllowIp({
        agencyCode,
        ipAddress,
      })
    },
    destroy(id: string, ipAddress: string, agencyCode: string) {
      return destroyAgencyAllowIp(id, ipAddress, agencyCode)
    },
  }
}
